import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { toast } from '@/lib/toast'

/** ⧉ next to an e-mail address or phone number (design §4.5). */
export function CopyButton({ value, label }: { value: string; label: string }) {
  async function copy() {
    try {
      await navigator.clipboard.writeText(value)
      toast.success('Gekopieerd.')
    } catch {
      toast.error('Kopiëren mislukt.')
    }
  }
  return (
    <Button type="button" size="icon-xs" variant="ghost" aria-label={label} title={label} onClick={() => void copy()}>
      <Copy aria-hidden />
    </Button>
  )
}
